import React from 'react';

export const SearchSort = ({ options, currentSort, onSortChange }) => (
  <div>
    <label htmlFor="sort-by" className="hidden">Sort by</label>
    <select
      id="sort-by"
      value={currentSort}
      onChange={(e) => onSortChange(e.target.value)}
      className="nsw-form__select"
    >
      {Object.entries(options).map(([value, label]) => (
        <option key={value} value={value}>
          {label}
        </option>
      ))}
    </select>
  </div>
);
